var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjectFeaturedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H38C43.5229 0 48 4.47715 48 10V38C48 43.5229 43.5228 48 38 48H10C4.47715 48 0 43.5228 0 38V10Z",
    fill: "#E1E3EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33 30L31.9999 31.094C31.4695 31.6741 30.7502 32 30.0002 32C29.2501 32 28.5308 31.6741 28.0004 31.094C27.4693 30.5151 26.75 30.1901 26.0002 30.1901C25.2504 30.1901 24.5312 30.5151 24 31.094M15 32H16.6746C17.1638 32 17.4083 32 17.6385 31.9447C17.8426 31.8957 18.0377 31.8149 18.2166 31.7053C18.4185 31.5816 18.5914 31.4086 18.9373 31.0627L31.5001 18.5C32.3285 17.6716 32.3285 16.3284 31.5001 15.5C30.6716 14.6716 29.3285 14.6716 28.5001 15.5L15.9373 28.0627C15.5914 28.4086 15.4184 28.5816 15.2948 28.7834C15.1851 28.9624 15.1043 29.1575 15.0553 29.3615C15 29.5917 15 29.8363 15 30.3255V32Z",
    stroke: "#242844",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectFeaturedIcon);
export default __webpack_public_path__ + "static/media/project-featured-icon.2702789c1a226ea25cec28943dd5e64d.svg";
export { ForwardRef as ReactComponent };